import styled from 'styled-components';
import { breakpoints, colors, font } from '@chegg-ui/theme';
export var SaleBadgeContainer = styled.div.withConfig({
  componentId: "sc-c3h2qq-0"
})(["position:relative;font-weight:", ";"], font.weight.bold);
export var SaleBadgeLabel = styled.div.withConfig({
  componentId: "sc-c3h2qq-1"
})(["position:absolute;top:0;bottom:0;left:0;right:0;display:flex;align-items:center;justify-content:center;"]);
export var SolidBadgeText = styled.div.withConfig({
  componentId: "sc-c3h2qq-2"
})(["color:", ";font-size:", ";@media (min-width:", "){font-size:", ";}"], colors.white, font.size.px14, breakpoints.xl.min, font.size.px16);
export var OutlineBadgeText = styled.div.withConfig({
  componentId: "sc-c3h2qq-3"
})(["color:", ";font-size:", ";"], colors.cheggOrange, font.size.px12);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SaleBadgeMMVariant/styled.js
// module id = 3993
// module chunks = 11